import React from "react";
import T from "prop-types";
import { get } from "lodash";
import {
  DetailTable,
  Detail,
  CheckForDetail
} from "MODULES/shared/components/DetailTable";
import Section from "MODULES/shared/components/Section";
import { ApprovalLabel } from "MODULES/shared/components";
import { APPROVED, DENIED } from "MODULES/companies/constants";
import pojo from "LIB/pojos";
import {
  REPAIR_STATION_WARRANTY_STATUS,
  VENDOR_WARRANTY_AMOUNT,
  VENDOR_WARRANTY_AMOUNT_PAID,
  WARRANTY_CHARGES_INVOICED,
  WARRANTY_CONSIDERATION,
  WARRANTY_STATUS
} from "MODULES/RMAsAndWarranties/constants";
import { properCase } from "LIB/formatters/text";
import Form from "./Form";
import RecentOrderRow from "../../../../../inventories/components/Detail/RecentOrderRow";

export const finalWarrantyApproval = rma => {
  if ([null, ""].includes(rma.warranty_status)) return null;
  return rma.warranty_status &&
    rma.repair_station_warranty_status === DENIED &&
    rma.warranty_status === DENIED
    ? DENIED
    : APPROVED;
};

export default function WarrantyConsideration({ rma }) {
  if (get(rma, "inventory.managed_repair_in_progress")) return null;
  const title =
    rma.type === "CustomerRma"
      ? "Edit Warranty Consideration Details"
      : "Edit Vendor Warranty Consideration Details";

  const vendorWarrantyAmount = parseFloat(get(rma, VENDOR_WARRANTY_AMOUNT, 0));
  const vendorWarrantyAmountPaid = parseFloat(
    get(rma, VENDOR_WARRANTY_AMOUNT_PAID, 0)
  );

  const initialValues = {
    ...pojo(rma).pick(
      VENDOR_WARRANTY_AMOUNT,
      VENDOR_WARRANTY_AMOUNT_PAID,
      WARRANTY_CHARGES_INVOICED,
      WARRANTY_CONSIDERATION,
      WARRANTY_STATUS,
      REPAIR_STATION_WARRANTY_STATUS
    ),
    warranty_amount_paid: vendorWarrantyAmountPaid >= vendorWarrantyAmount
  };

  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <Section
        title={properCase(WARRANTY_CONSIDERATION)}
        modal={{
          title,
          content: close => (
            <Form close={close} rma={rma} initialValues={initialValues} />
          )
        }}
      >
        <DetailTable>
          <CheckForDetail
            label="Warranty Consd Req?"
            value={rma.warranty_consideration}
          />
          {rma.warranty_consideration && (
            <React.Fragment>
              <CheckForDetail
                label="Warranty Charges"
                value={rma.warranty_charges_invoiced}
              />
              <RecentOrderRow
                record={rma}
                type="warranty_consideration_repair_item"
                rootLink="repair-orders"
                title="Warranty Consideration RO"
              />
              <Detail
                label="Warranty Status"
                value={<ApprovalLabel status={rma.warranty_status} />}
              />
              {rma.type === "CustomerRma" && (
                <Detail
                  label="Rep. Station Warranty"
                  value={
                    <ApprovalLabel
                      status={rma.repair_station_warranty_status}
                    />
                  }
                />
              )}
              <Detail
                label="Final Warranty Approval"
                value={<ApprovalLabel status={finalWarrantyApproval(rma)} />}
              />
            </React.Fragment>
          )}
        </DetailTable>
      </Section>
    </React.Fragment>
  );
}

WarrantyConsideration.propTypes = {
  rma: T.shape({
    warranty_consideration: T.bool,
    warranty_status: T.string,
    repair_station_warranty_status: T.string
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/WarrantyConsideration/WarrantyConsideration.jsx